import { sendHTTPRequest } from '@/util/http'
import { goalbookUrls } from '@/util/links'
import { getStrategies } from '@/strategies/api'

const toolkitUrl = import.meta.env.VITE_TOOLKIT_URL

export interface GoalCharacteristic {
  Uuid: string
  Label: string
}

export interface StrategyOption {
  uuid: string
  title: string
}

export interface SubjectsDomainsGrades {
  subjects: string[]
  subjectDomainsMap: Record<string, string[]>
  subjectGradesMap: Record<string, string[]>
}

// Each entry is { <subject>: domains, grades }: the subject is the one key that is not "grades".
type SubjectEntry = Record<string, string[]> & { grades: string[] }

// The Vue 2 editor's cap; strategies past it can't be picked until it is raised.
const STRATEGY_OPTION_LIMIT = 400

export async function getGoalCharacteristics(signal?: AbortSignal): Promise<GoalCharacteristic[]> {
  const response = await sendHTTPRequest({ url: `${goalbookUrls.pathwaysApi}/goal_characteristics`, signal })
  return await response.json() as GoalCharacteristic[]
}

export async function getStrategyOptions(signal?: AbortSignal): Promise<StrategyOption[]> {
  return getStrategies({ size: STRATEGY_OPTION_LIMIT, fields: 'uuid,title' }, signal)
}

export async function getSubjectsDomainsGrades(): Promise<SubjectsDomainsGrades> {
  const response = await sendHTTPRequest({ url: `${toolkitUrl}/api/subjects`, urlParams: { refetch: '1' } })
  const entries = await response.json() as SubjectEntry[]

  const result: SubjectsDomainsGrades = { subjects: [], subjectDomainsMap: {}, subjectGradesMap: {} }
  entries.forEach(entry => {
    const subject = Object.keys(entry).find(key => key !== 'grades')
    if (!subject) return
    result.subjects.push(subject)
    result.subjectDomainsMap[subject] = entry[subject]
    result.subjectGradesMap[subject] = entry.grades
  })
  return result
}
